import Header from "../components/Header";
import styles from "./LegalPage.module.css";

export default function Impressum() {
  return (
    <div className={styles.legalPage}>
      <Header />
      <div className={styles.content}>
        <h1>Impressum</h1>
        <section>
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            stahlfaktor<br />
            Neuenlander Str. 24<br />
            58256 Ennepetal
          </p>
        </section>
        <section>
          <h2>Vertreten durch</h2>
          <p>Melanie Brücher-Kümmel<br />Geschäftsführerin</p>
        </section>
        <section>
          <h2>Kontakt</h2>
          <p>
            Telefon: 02333/616101<br />
            E-Mail: info@stahlfaktor.de
          </p>
        </section>
        <section>
          <h2>Quellenangaben</h2>
          <p>
            Corporate Design und Illustrationen: <a href="mailto:hallo@merletebbe.de">Merle Tebbe</a><br />
            Programmierung: <a href="mailto:ferdinand.baumgarten@yahoo.com">Ferdinand Baumgarten</a><br />
            Keyvisual: Adobe Stock
          </p>
        </section>
      </div>
    </div>
  );
}
